import Layout from '@/layouts/layout';
import { Heading } from '@ingeniorforeningen/figurine-core';
import React from 'react';

type Props = {};

const Home = () => {
  return (
    <>
      <Layout>
        <Heading type="display" text="IDA Conference" />
      </Layout>
    </>
  );
};

export default Home;
